function DownloadButtons() {
  return (
    <div className="w-full py-8 sm:py-10 flex flex-col justify-center items-center bg-white pb-20 sm:pb-40">
      <h3 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6 text-black text-center">
        Get Our App
      </h3>
      <div className="flex flex-wrap gap-3 sm:gap-4 justify-center px-4">
        <button className="flex items-center gap-2 px-4 sm:px-5 py-2 sm:py-3 bg-white text-black rounded-lg text-sm sm:text-base font-medium shadow-md hover:bg-gray-200 transition w-full sm:w-auto justify-center">
          Google Play
        </button>
        <button className="flex items-center gap-2 px-4 sm:px-5 py-2 sm:py-3 bg-white text-black rounded-lg text-sm sm:text-base font-medium shadow-md hover:bg-gray-200 transition w-full sm:w-auto justify-center">
          App Store
        </button>
      </div>
    </div>
  );
}

export default DownloadButtons;
